import { render, staticRenderFns } from "./RegionManage.vue?vue&type=template&id=aa7fd8a8&scoped=true"
import script from "./RegionManage.vue?vue&type=script&lang=js"
export * from "./RegionManage.vue?vue&type=script&lang=js"
import style0 from "./RegionManage.vue?vue&type=style&index=0&id=aa7fd8a8&prod&scoped=true&lang=css"
import style1 from "./RegionManage.vue?vue&type=style&index=1&id=aa7fd8a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7fd8a8",
  null
  
)

export default component.exports